import { Container } from 'inversify';
import { reactive } from 'vue';
import {
	INewsContentService,
	IPopupService,
	IQuizLoaderService,
	type MakeReactive,
	NewsCategoryStore,
	NewsTitlesStore,
	NewsTranslationStore
} from '@lingvo-news/contracts';
import { serviceContainer } from '../store/service-container';
import { SERVICE_TYPES } from '../store/service-container';
import { PopupServiceImpl } from './popup-service-impl';
import { QuizLoaderServiceImpl } from './quiz-loader-service-impl';
import { bindHttpServiceClients } from './services/http-service-client-registrar';

const vueMakeReactive: MakeReactive<unknown> = (obj: unknown): unknown => {
	if (obj && typeof obj === 'object') {
		return reactive(obj as object);
	}
	return obj;
};

export class ClientSideServiceBuilder {
	build(): Container {
		const container = serviceContainer;
		bindHttpServiceClients(container, container.get<string>(SERVICE_TYPES.ApiBaseUrl));

		if (!container.isBound(IPopupService)) {
			container.bind(IPopupService).to(PopupServiceImpl).inSingletonScope();
		}

		if (!container.isBound(IQuizLoaderService)) {
			container.bind(IQuizLoaderService).to(QuizLoaderServiceImpl).inSingletonScope();
		}

		// News stores
		if (!container.isBound(NewsCategoryStore)) {
			container
				.bind(NewsCategoryStore)
				.toDynamicValue((ctx) => new NewsCategoryStore(ctx.container.get(INewsContentService), vueMakeReactive))
				.inSingletonScope();
		}

		if (!container.isBound(NewsTitlesStore)) {
			container
				.bind(NewsTitlesStore)
				.toDynamicValue((ctx) => new NewsTitlesStore(ctx.container.get(INewsContentService), vueMakeReactive))
				.inSingletonScope();
		}

		if (!container.isBound(NewsTranslationStore)) {
			container
				.bind(NewsTranslationStore)
				.toDynamicValue((ctx) => new NewsTranslationStore(ctx.container.get(INewsContentService), vueMakeReactive))
				.inSingletonScope();
		}

		return container;
	}
}


